module.exports = __webpack_public_path__ + "static/img/loading_2.77ddb7b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/loading_2.gif
// module id = ViAD
// module chunks = 1